<template>
    <div class="loading-screen-full row justify-content-center">
        <div class="col-2">
            <div class="loader">
                <span class="loader__progress">&nbsp;</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Loader"
    }
</script>

<style scoped lang="stylus">
    .loading-screen-full
        .loader
            display flex
            position fixed
            z-index 100
            top 0
            left 0
            width 100vw
            height 100vh
            justify-content center
            align-items center
            background-color #ffffff
            transition all .3s

            &__progress
                width 10rem
                height 10rem
                border 5px solid #004666
                border-left-color transparent
                border-radius 50%
                animation rotate 1.5s linear infinite

            @-webkit-keyframes rotate
                from
                    -webkit-transform rotate(0deg)
                to
                    -webkit-transform rotate(360deg)
</style>